// Feature keys del framework de rollout. El slug coincide con el nombre del build flag
// (ENABLE_MENU_V2 = flag 'menu-v2') y con feature.feature_key en el backend.
export const MENU_FEATURE_KEY = 'menu-v2';

// Impresión térmica por Web Bluetooth (PR #1031). Feature COMPLETA del framework (A/B +
// invitación + switch de versión). Particularidad vs menu-v2: las superficies de invitación
// además se gatean por COMPATIBILIDAD del dispositivo (isWebBleSupported + isSecureContext) —
// la asignación es per-comercio pero la capacidad BT es per-dispositivo; no se invita donde
// la funcionalidad no puede usarse.
export const BLE_FEATURE_KEY = 'impresion-ble';

// Chat de soporte/CS (Paulina) gateado por el framework de rollout. Default seguro: con el
// build-flag 'agent-chat' AUSENTE (hoy), Paulina se monta para TODOS como hasta ahora; con el
// flag ON, el montaje pasa a depender del rollout per-comercio (treatment). Misma feature
// COMPLETA del framework que menu-v2/impresion-ble (A/B + invitación + telemetría).
export const AGENT_CHAT_FEATURE_KEY = 'agent-chat';

// Pedidos programados — migración módulo (`modulos_extra.SCHEDULED_ORDERS`) → rollout 100%
// (gate único, decisión CTO 2026-07-10: capability gratuita GA-para-todos). Durante la
// transición el gate efectivo es módulo OR rollout (ver useScheduledOrdersGate.ts); no es
// una feature de invitación/A-B como menu-v2 o impresion-ble.
export const SCHEDULED_ORDERS_FEATURE_KEY = 'scheduled-orders';

// Registro tipado de las feature keys del rollout (SPEC-8). `FeatureKey` es el union que
// consumen la fábrica de gates y el hook base: un typo en el slug HOY compila y crea una
// feature fantasma (cache/telemetría propios, GETs 404 silenciosos) — con el union, no
// compila. Toda feature nueva se agrega AQUÍ (y su flag en los vite.config.*).
export const FEATURE_KEYS = [
  MENU_FEATURE_KEY,
  BLE_FEATURE_KEY,
  AGENT_CHAT_FEATURE_KEY,
  SCHEDULED_ORDERS_FEATURE_KEY,
] as const;
export type FeatureKey = (typeof FEATURE_KEYS)[number];
